import Vue from '@/main'

export const campaignUpdated = (data) => {
  console.log('socket CampaignUpdated received')
  Vue.$events.fire('CampaignUpdated', data)
}

export const chatNotification = (data) => {
  console.log('socket ChatNotification received')
  Vue.$events.fire('ChatNotification', data)
}

export const chatTicketClosed = (data) => {
  console.log('socket ChatTicketClosed received')
  Vue.$events.fire('ChatTicketClosed', data)
}

export const chatTicketTransferred = (data) => {
  console.log('socket ChatTicketTransferred received')
  Vue.$events.fire('ChatTicketTransferred', data)
}

export const chatTicketTransferring = (data) => {
  console.log('socket ChatTicketTransferring received')
  Vue.$events.fire('ChatTicketTransferring', data)
}

export const customerBlacklisted = (data) => {
  console.log('socket CustomerBlacklisted received')
  Vue.$events.fire('CustomerBlacklisted', data)
}

export const customerChatCreated = (data) => {
  console.log('socket CustomerChatCreated received')
  Vue.$events.fire('CustomerChatCreated', data)
}

export const customerChatAckChanged = (data) => {
  console.log('socket CustomerChatAckChanged received')
  Vue.$events.fire('CustomerChatAckChanged', data)
}

export const chatTicketTransfer = (data) => {
  console.log('socket ChatTicketTransfer received')
  Vue.$events.fire('ChatTicketTransfer', data)
}

export const customerCreatedToChat = (data) => {
  console.log('socket CustomerCreatedToChat received')
  Vue.$events.fire('CustomerCreatedToChat', data)
}

export const groupOfCustomersUpdated = (data) => {
  console.log('socket GroupOfCustomersUpdated received')
  Vue.$events.fire('GroupOfCustomersUpdated', data)
}

export const instanceUpdated = (data) => {
  console.log('socket InstanceUpdated received')
  Vue.$events.fire('InstanceUpdated', data)
}

export const deleteChatTicketTransfer = (data) => {
  console.log('socket DeleteChatTicketTransfer received')
  Vue.$events.fire('DeleteChatTicketTransfer', data)
}

export const ping = (data) => {
  console.log('socket pong received', data)
}
